import { OurNode } from "@src/cloud-connect/poc/our-node";
import { getNodeManager } from "@src/cloud-connect/dependency-injection-container/get-node-manager";

export const useCaretOurNodeInitialHook = () => {
  const handleCaretClick = (node: OurNode) => {
    const nodeManager = getNodeManager();

    nodeManager.getInitialCaretClickHandler().toggleExpanded(node);
  };

  return {
    handleCaretClick: handleCaretClick,
  };
};
